import { Component, Output, ViewChild, EventEmitter } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";

import { CameraComponent } from "../../camera/camera.component";
import { PdfService } from "../../../service/pdf.service";

@Component({
  selector: "app-pdf-upload-form",
  templateUrl: "./pdf-upload-form.component.html",
  styleUrls: ["pdf-upload-form.component.css"],
})
export class PdfUploadFormComponent {
  constructor(private pdfService: PdfService) {}

  pdfFiles: File[] = [];

  previewUrl: SafeResourceUrl = null;

  @ViewChild(CameraComponent) camera: CameraComponent;

  @Output() uploadFileEmit = new EventEmitter<File>();

  openCamera() {
    this.camera.startCamera();
  }

  /**
   * PDFを結合し、iframeでプレビュー表示できるよう変換
   * @async
   */
  async openPreview() {
    this.previewUrl = null;
    this.previewUrl = await this.pdfService.getPreviewPdfUrl(this.pdfFiles);
    this.pdfService.pdfPreviewModalOpen(
      this.previewUrl,
      true,
      (modalresult) => {
        if (modalresult.status == "ok") {
          this.upload();
        }
      }
    );
  }

  /**
   * PDFを結合し、iframeでプレビュー表示できるよう変換
   * @async
   */
  async openThumbnail() {
    this.pdfService.pdfThumbnailListModalOpen(
      this.pdfFiles,
      (modalresult: any) => {
        if (modalresult.status == "ok") {
          this.pdfFiles = modalresult.pdf;
          if (this.pdfFiles.length === 0) {
            this.pdfFiles = [];
          }
        }
      }
    );
  }

  /**
   * PDFを結合し、アップロード
   * @async
   */
  async upload() {
    const buffers: ArrayBuffer[] = [];

    for (const file of this.pdfFiles) {
      const buffer = await this.pdfService.readAsArrayBuffer(file);
      buffers.push(buffer);
    }
    const merged = await this.pdfService.mergePdfs(buffers);

    const safeBytes = new Uint8Array(merged.length);
    safeBytes.set(merged);

    const uploadFile = new File([safeBytes], "upload.pdf", {
      type: "application/pdf",
    });
    this.uploadFileEmit.emit(uploadFile);
  }

  /**
   * PDF選択時の処理
   * @param {event} any ファイル選択イベント
   * @returns
   */
  public async onFilesSelected(event: any) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      if (f.type === "application/pdf") {
        this.pdfFiles.push(f);
      }
      if (f.type === "image/png" || f.type === "image/jpeg") {
        const extension = f.type === "image/png" ? "PNG" : "JPEG";
        const dataUrl = await this.pdfService.fileToDataURL(f);
        const test = await this.pdfService.getOrientationFromDataUrl(dataUrl);
        console.log(test);
        const pdfBuffer = this.pdfService.generatePdfFromImage(
          dataUrl,
          test,
          extension
        );
        const file = new File(
          [pdfBuffer],
          "写真選択" + (this.pdfFiles.length + 1) + ".pdf",
          {
            type: "application/pdf",
          }
        );
        this.pdfFiles.push(file);
      }
    }
    // 再選択可能にする
    event.target.value = '';
  }

  /**
   * カメラコンポーネントが終了した際の処理
   * @param {photoList} string[] 写真のファイル群
   * @returns
   */
  async onCaptureFinished(photoList: string[]) {
    for (const img of photoList) {
      const pdfBuffer = this.pdfService.generatePdfFromImage(img);
      const file = new File(
        [pdfBuffer],
        "撮影" + (this.pdfFiles.length + 1) + ".pdf",
        {
          type: "application/pdf",
        }
      );
      this.pdfFiles.push(file);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/parts/pdf/pdf-upload-form/pdf-upload-form.component.ts